import React, { useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { FormattedMessage } from 'react-intl'

import { HouseNightlyTripGlobalDto } from '../../../../../../../../../../lib/graphql'
import { InformativeBlock } from '../../../../../../../../../atoms'
import { ControlledTextField } from '../../../../../../../../../forms'
import { formatMoney } from '../../../../../../../shared/utils/format/format-money/format-money'
import { HouseNightlyTripGlobalFieldProps } from '../../../form-container/HouseNightlyTripGlobalFormContainer'

export const HouseNightlyTripIndividualFlexibleSchedule = ({
  control,
  currencyArea,
  isFieldDisabled,
}: HouseNightlyTripGlobalFieldProps) => {
  const fieldProps = {
    disabled: isFieldDisabled,
    control,
    type: 'number',
    inline: true,
    rules: {},
    placeholder: formatMoney({ value: 0, currency: currencyArea.currency }),
  }

  const { setValue } = useFormContext<HouseNightlyTripGlobalDto>()

  const [showEarlyChekinInfo, setshowEarlyChekinInfo] = useState(false)
  const [showLateCheckoutInfo, setshowLateCheckoutInfo] = useState(false)

  return (
    <>
      <ControlledTextField
        {...fieldProps}
        name='options.flexibleSchedule.earlyCheckinPrice'
        formatValue={(value) =>
          formatMoney({ value, currency: currencyArea.currency })
        }
        onReset={() =>
          setValue('options.flexibleSchedule.earlyCheckinPrice', null, {
            shouldDirty: true,
          })
        }
        label={
          <>
            <FormattedMessage
              id='ui.HouseNightlyTripIndividualFlexibleSchedule.AllowEarlyCheckIn'
              defaultMessage="Autorisez-vous <b>l'arrivée anticipée</b> des voyageurs à <b>10h00</b> contre un supplément ?"
              values={{
                b: (chunks) => <b>{chunks}</b>,
              }}
            />
            <InformativeBlock
              displayBlock={showEarlyChekinInfo}
              setDisplayBlock={setshowEarlyChekinInfo}
              style={{ display: 'inline-flex' }}
              styleIcon={{ transform: 'translate(4px, 2px)' }}
            >
              <FormattedMessage
                id='ui.HouseNightlyTripIndividualFlexibleSchedule.recommendEarlyCheckIn'
                defaultMessage="Les logements qui proposent l'arrivée anticipée sont très demandés sur Naboo. Nous recommandons un
              supplément équivalent à 25% du prix moyen d'une nuitée en semaine."
                values={{
                  b: (chunks) => <b>{chunks}</b>,
                }}
              />
            </InformativeBlock>
          </>
        }
      />

      <ControlledTextField
        {...fieldProps}
        name='options.flexibleSchedule.lateCheckoutPrice'
        formatValue={(value) =>
          formatMoney({ value, currency: currencyArea.currency })
        }
        onReset={() =>
          setValue('options.flexibleSchedule.lateCheckoutPrice', null, {
            shouldDirty: true,
          })
        }
        label={
          <>
            <FormattedMessage
              id='ui.HouseNightlyTripIndividualFlexibleSchedule.AllowLateCheckOut'
              defaultMessage='Autorisez-vous le <b>départ tardif</b> des voyageurs à <b>18h00</b> contre un supplément ?'
              values={{
                b: (chunks) => <b>{chunks}</b>,
              }}
            />
            <InformativeBlock
              displayBlock={showLateCheckoutInfo}
              setDisplayBlock={setshowLateCheckoutInfo}
              style={{ display: 'inline-flex' }}
              styleIcon={{ transform: 'translate(4px, 2px)' }}
            >
              <FormattedMessage
                id='ui.HouseNightlyTripIndividualFlexibleSchedule.recommendLateCheckOut'
                defaultMessage=" Les logements qui proposent le départ tardif sont très demandés sur Naboo. Nous recommandons un supplément
              équivalent à 25% du prix moyen d'une nuitée en semaine."
                values={{
                  b: (chunks) => <b>{chunks}</b>,
                }}
              />
            </InformativeBlock>
          </>
        }
      />
    </>
  )
}
